package com.ucasoft.komm.website.pages.annotations

val annotationData = listOf(
    kommMap,
    mapFunction,
    mapName,
    mapEmbedded,
    mapConvert,
    mapResolve,
    mapTargetDefault,
    nullSubstitute
)
